import { Component, OnInit, Input, OnChanges,ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-shared',
  templateUrl: './shared.component.html',
  styleUrls: ['./shared.component.scss']
})
export class SharedComponent implements OnInit {

  constructor(private router: Router, private http: HttpClient, private route: ActivatedRoute,
              private utils: UtilsService) {
    
  }
  ngOnInit() {
}

}
